import { OnInit } from '@angular/core';
import { LoginService } from './login.service';
import { Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { LoaderService } from '../loader/loader.service';
import { ExternalAuthService } from '../auth/external-auth.service';
var LoginComponent = /** @class */ (function () {
    function LoginComponent(notifier, loaderService, formBuilder, loginService, router, externalAuthService) {
        this.notifier = notifier;
        this.loaderService = loaderService;
        this.formBuilder = formBuilder;
        this.loginService = loginService;
        this.router = router;
        this.externalAuthService = externalAuthService;
        // variables
        this.hide = false;
        this.submitted = false;
        this.rollId = localStorage.getItem('rollId');
        this.errorStatus = false;
        this.locked = false;
        this.btn = false;
        this.ssoProviders = [];
        this.isSsoInProgress = false;
    }
    LoginComponent.prototype.ngOnInit = function () {
        var _this = this;
        var submainName = window.location.hostname.split(".")[0];
        this.loginService.getImageUrl(submainName).subscribe(function (res) {
            _this.imgUrl = res;
        });
        $(function () {
            $('#noSpacesField').bind('input', function () {
                $(this).val(function (_, v) {
                    return v.replace(/\s+/g, '');
                });
            });
        });
        this.registerForm = this.formBuilder.group({
            email: ['', [Validators.required]],
            password: ['', [Validators.required, Validators.minLength(8)]]
        });
        this.ssoProviders = this.externalAuthService.getEnabledProviders();
    };
    Object.defineProperty(LoginComponent.prototype, "f", {
        get: function () {
            return this.registerForm.controls;
        },
        enumerable: true,
        configurable: true
    });
    // Onsubmit (login function)
    LoginComponent.prototype.onSubmit = function () {
        var _this = this;
        this.submitted = true;
        //  stop here if form is invalid
        if (this.registerForm.invalid) {
            this.errorStatus = false;
            return;
        }
        // document.getElementById('myModal').style.display='block'
        this.loginService.login(this.registerForm.value).subscribe(function (res) {
            var session = _this.loginService.getStoredSession();
            if (session) {
                _this.navigateAfterLogin(session);
            }
        }, function (error) {
            _this.errorStatus = true;
            _this.error = error.error;
            // document.getElementById('myModal').style.display='none'
            _this.notifier.notify('error', _this.error.message);
            _this.loginError = _this.error.message;
            _this.locked = _this.error.isAccountLocked;
            if (_this.locked) {
                $('#myModalz').modal('show');
            }
        });
    };
    LoginComponent.prototype.startExternalLogin = function (provider) {
        if (!provider || !provider.id || this.isSsoInProgress) {
            return;
        }
        this.isSsoInProgress = true;
        this.registerForm.disable({ emitEvent: false });
        this.btn = false;
        try {
            var callbackUrl = this.buildCallbackUrl();
            this.externalAuthService.beginExternalLogin(provider.id, callbackUrl);
        }
        catch (error) {
            this.isSsoInProgress = false;
            this.registerForm.enable({ emitEvent: false });
            this.notifier.notify('error', 'Unable to initiate single sign-on. Please try again.');
        }
    };
    LoginComponent.prototype.buildCallbackUrl = function () {
        return this.externalAuthService.getSpaCallbackUrl();
    };
    LoginComponent.prototype.navigateAfterLogin = function (session) {
        var navigation = this.loginService.determinePostLoginNavigation(session);
        if (!navigation || !navigation.commands) {
            return;
        }
        if (navigation.showLoader) {
            this.loaderService.show();
        }
        this.router.navigate(navigation.commands);
    };
    LoginComponent.prototype.validatez = function () {
        var reg = /^\w+([-+.']\w+)*@\w+([-. ]\w+)*\.\w+([-. ]\w+)*$/;
        if (reg.test(this.registerForm.value.email.trim())) {
            this.emailErrz = false;
        }
        else {
            this.emailErrz = true;
        }
    };
    // Google captch function
    LoginComponent.prototype.resolved = function (captchaResponse) {
        this.googleResponse = captchaResponse;
        if (this.googleResponse != null && this.registerForm.value) {
            this.btn = true;
        }
        else {
            this.btn = false;
        }
    };
    return LoginComponent;
}());
export { LoginComponent };
